export default __webpack_public_path__ + "static/media/nba-logo.0509eed5.svg";